import React from "react";
import { acaraPerusahaanBreadcrumb } from "../../../data/DataBreadcrumb";
import { acaraPerusahaanMeta } from "../../../data/DataMetatags";

import {
  DetailSlugContentAboutCompany,
  DetailSlugContentAboutCompanyValidator
} from "../../../components/global/DetailContent";

const detailAcaraPerusahaan = ({ datas }) => {
  return <DetailSlugContentAboutCompany datas={datas} />;
};

detailAcaraPerusahaan.getInitialProps = async ({ res, asPath, query }) => {
  const { slug } = query;
  const { description } = acaraPerusahaanMeta;

  return DetailSlugContentAboutCompanyValidator(
    slug,
    res,
    asPath,
    acaraPerusahaanBreadcrumb,
    description,
    "Acara Perusahaan",
    "acara-perusahaan",
    "event-details"
  );
};

export default detailAcaraPerusahaan;
